import { IntegrationCode, IntegrationCodeType } from '../../enums/integrationCode';
import { RentalUnit } from './unit.data';

export type UnitCode = IntegrationCode;

export namespace UnitCode {
  /**
   * Get rental unit unitCode (old: MPK)
   * @deprecated use IntegrationCode.fromIntegrationCode
   * @param {RentalUnit} unit
   * @return {string | null} unitCode.fliko / unitCode.legacy / unitCode.other or unit.mpk or null
   */
  export function fromRentalUnit(unit: RentalUnit): string | null {
    return IntegrationCode.fromIntegrationCode(unit.unitCodes);
  }

  /**
   * Get ALL unitCodes from unit
   * @deprecated use IntegrationCode.allCodesFromObj
   * @param {RentalUnit} unit
   * @return {string[]}
   */
  export function allFromUnit(unit: RentalUnit): string[] {
    return Array.from(IntegrationCode.allCodesFromObj(unit.unitCodes));
  }

  /**
   * Return translation key for IntegrationCodeType enum
   * @param {IntegrationCodeType | string} type
   * @return {string}
   */
  export function transKey(type: IntegrationCodeType | string): string {
    return `unitCode.${type}`;
  }
}
